import { render, staticRenderFns } from "./NowLoading.vue?vue&type=template&id=3fb8da0c&scoped=true&lang=pug&"
import script from "./NowLoading.vue?vue&type=script&lang=js&"
export * from "./NowLoading.vue?vue&type=script&lang=js&"
import style0 from "./NowLoading.vue?vue&type=style&index=0&id=3fb8da0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb8da0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
